export type AlarmDropDownItem = {
    propertyName?: string;
    name: string;
    setPoint?: number;
};

export const defaultAlarmDropDownItem: AlarmDropDownItem[] = [
    {
        propertyName: 'normal',
        name: 'repose-group.dialog.title.normal-range-nodata',
        setPoint: null,
    },
    {
        propertyName: 'alarmSettingVeryHigh',
        name: 'repose-group.dialog.title.high-high',
        setPoint: null,
    },
    {
        propertyName: 'alarmSettingHigh',
        name: 'repose-group.dialog.title.high',
        setPoint: null,
    },
    {
        propertyName: 'alarmSettingLow',
        name: 'repose-group.dialog.title.low',
        setPoint: null,
    },
    {
        propertyName: 'alarmSettingVeryLow',
        name: 'repose-group.dialog.title.low-low',
        setPoint: null,
    },
    {
        propertyName: 'alarmSettingFeedbackError',
        name: 'repose-group.dialog.title.feedback',
        setPoint: null,
    },
    {
        propertyName: 'alarmSettingSensorFail',
        name: 'repose-group.dialog.title.sensor-failure',
        setPoint: null,
    },
];
